(function () {
  'use strict';

  angular.module('app').service('PriceListModalService', PriceListModalService);

  PriceListModalService.$inject = ['ModalService'];

  function PriceListModalService(ModalService) {
    var service = {
      openPriceLists: openPriceLists,
      openPriceListDetail: openPriceListDetail,
    };

    return service;

    /////////////////////

    function openPriceLists(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/price-lists/modals/price-list-modal.html',
        controller: PriceListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });
    }

    function PriceListModalCtrl(PriceListService, AbilityService, UtilService) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_pricelist_accountadmin'),
        canCreate: AbilityService.can('create_pricelist_accountadmin'),
        canShow: AbilityService.can('show_pricelist_accountadmin'),
      };

      // Methods
      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      vm.onDeletedItem = onDeletedItem;

      // Initializers
      getItems();
      //getAdditionalLanguages();

      function getItems() {
        if (vm.permissions.canList) {
          vm.loadingItems = true;
          PriceListService.getPriceLists().then(function (data) {
            vm.items = data.items;
            vm.meta = data.meta;

            vm.loadingItems = false;
          });
        }

        vm.modalTitle = 'PRICE_LISTS';
      }

      // function getAdditionalLanguages() {
      //     LanguageService.getLanguages({ get: 'translations' }).then(function () {
      //         vm.additionalLanguages = LanguageService.items;
      //     });
      // }

      function getItem(item) {
        vm.item = null;
        PriceListService.getPriceList(item.id).then(function (data) {
          vm.item = data;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_PRICE_LIST';
      }

      function onSavedItem(item) {
        vm.UtilService._clearFlashMessage();
        getItem(item);
      }

      function cancel() {
        vm.createMode = false;
        vm.editMode = false;

        getItems();
      }

      function onCanceledItem() {
        cancel();
      }

      function onShowItem(item) {
        vm.editMode = true;
        vm.modalTitle = 'PRICE_LIST_DETAILS';

        getItem(item);
      }

      function onDeletedItem() {
        cancel();
      }
    }

    function openPriceListDetail(itemId, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/price-lists/modals/price-list-detail-modal.html',
        controller: PriceListModalDetailCtrl,
        controllerAs: 'vm',
        inputs: {
          itemId: itemId,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          //successCallback(vm.item);
        });
      });
    }

    function PriceListModalDetailCtrl(
      $element,
      itemId,
      successCallback,
      PriceListService,
      LanguageService
    ) {
      var vm = this;

      vm.onSavedItem = onSavedItem;
      vm.onCanceledItem = onCanceledItem;

      getAdditionalLanguages();

      PriceListService.getPriceList(itemId).then(function (data) {
        vm.item = data;
        vm.item.isModal = true;
      });

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ get: 'translations' }).then(function (data) {
          vm.additionalLanguages = data.items;
        });
      }

      function onSavedItem() {
        $element.modal('hide');
        successCallback(vm.item, true);
      }

      function onCanceledItem() {
        $element.modal('hide');
      }
    }
  }
})();
